// extracted by mini-css-extract-plugin
export default {"circularIcon":"tK665k69jVf2xBevgjyu"};